<template>
  <ValidationObserver
    ref="loginFormObserver"
    v-slot="{ valid }"
  >
    <VTextField
      ref="emailInput"
      v-model="data.email"
      v-autofocus
      type="email"
      :dark="true"
      outlined
      color="#ffffff"
      extraClass="mb-12"
      :rules="{ required: true, min: 1, max: 200, email: true }"
      :label="$t('forms.labels.email')"
      :dataCy="dataCy.loginForm.email"
    />
    <VPassword
      v-if="!isResetPassword"
      v-model="data.password"
      :dark="true"
      outlined
      color="#ffffff"
      :label="$t('forms.labels.password')"
      :rules="{ required: true, min: 1, max: 200 }"
      :required="!isResetPassword"
      :dataCy="dataCy.loginForm.password"
    />
    <SlotScopeWatcher
      :value="valid"
      @change="$emit('validChanged', valid)"
    />
  </ValidationObserver>
</template>

<script>
import { ValidationObserver } from 'vee-validate';
import validationProviderHelperMixin from '@/components/shared/widgets/forms/validationHelper/validationProviderHelperMixin';
import SlotScopeWatcher from '@/components/shared/widgets/forms/validationHelper/SlotScopeWatcher';
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import VPassword from '@/components/shared/widgets/forms/VuetifyInputs/VPassword.vue';
import { loginForm } from '@/aq-data-cy.json';
import autofocus from '@/utilities/directives/autofocus';

export default {
    directives: {
        autofocus,
    },
    components: {
        SlotScopeWatcher,
        ValidationObserver,
        VTextField,
        VPassword,
    },
    mixins: [
        validationProviderHelperMixin,
    ],
    props: {
        isResetPassword: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            data: {
                email: '',
                password: '',
                lang: this.$i18n.locale,
            },
        };
    },
    computed: {
        dataCy() {
            return {
                loginForm,
            };
        },
    },
    watch: {
        data: {
            handler() {
                this.updateData();
            },
            deep: true,
        },
    },
    mounted() {
        this.$nextTick(() => {
            const input = this.$refs.emailInput.$el.querySelector('input');
            if (input) input.focus();
        });
    },
    methods: {
        updateData() {
            this.$emit('sendData', this.data);
        },
    },

};
</script>

<style lang="scss">
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus {
    -webkit-text-fill-color: #fff;
    -webkit-box-shadow: 0 0 0px 1000px #262f4b inset;
    transition: background-color 5000s ease-in-out 0s;
  }
</style>
